<template>
  <div v-if="firstName" class="greeting">
    <p class="greeting__message"> {{ $t(userGreeting) }},</p>
    <p class="greeting__name">{{ firstName }}</p>
  </div>
</template>

<script>
import { getTimeOfDay } from '~/helpers'
import { TIMES_OF_DAY } from '~/constants'

const { MORNING, AFTERNOON, EVENING, NIGHT } = TIMES_OF_DAY

export default {
  props: {
    firstName: {
      type: String,
      required: true
    }
  },

  computed: {
    userGreeting () {
      const timeOfDay = getTimeOfDay()

      switch (timeOfDay) {
        case MORNING:
          return 'HOME_MORNING_HEADER'
        case AFTERNOON:
          return 'HOME_AFTERNOON_HEADER'
        case EVENING:
        default:
          return 'HOME_EVENING_HEADER'
        case NIGHT:
          return 'HOME_NIGHT_HEADER'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.greeting {
  display: flex;
  flex-direction: column;
  align-content: center;

  &__message {
    @include font('040');
    color: $color-gray_5;
    line-height: 1em;
  }
  &__name {
    @include font('060');
    color: $color-white;
    line-height: 1.125em;
  }
}
</style>
